import React from 'react';

import { useState } from 'react';
import { useSnackbarMessage } from '../SnackMessge.tsx';
import * as columns from '../../misc/Columns';
import { Dialog, Button, DialogActions } from '@mui/material';
import { NewOrEdit } from '../NewOrEdit.tsx';
import { useDependencies } from '../../misc/DependenciesProvider.tsx';
import * as dataManCommon from './DataManCommon.ts';
import * as general from '../../api/General.ts';

export function VocabEdit({
    columns,
    tabName,
    db_name_of_vocab,
    onHandleClose,
    initialEditData,
}: {
    columns: columns.ColumnInfo[],
    tabName: string,
    db_name_of_vocab: string,
    initialEditData: any,
    onHandleClose: () => void
}): JSX.Element {

    const [editData, setEditData] = useState<any>(initialEditData);
    const { showMessage } = useSnackbarMessage();
    const { fracAPI } = useDependencies();
    const [isEditing, setIsEditing] = useState(false);

    const handleClose = () => {
        onHandleClose();
    }


    const handleUpdate = async () => {
        try {
            setIsEditing(true);
            var data = dataManCommon.convertEditDataAsUpdate(db_name_of_vocab, editData, columns);
            await fracAPI.updateVocabularyRecord(data);

            setEditData(null);
            handleClose();
        }
        catch (error) {
            if (error instanceof general.UserErrorMessage) {
                showMessage(error.message);

            } else {
                console.error("Error updating record: " + error);
                showMessage("Error updating record. Please try again.");
            }

        } finally {
            setIsEditing(false);
        }
    }

    const handleChangedData = (data) => {
        setEditData(data);
    }

    return (
        <div>
            <Dialog onClose={handleClose} open={true}
                fullWidth={true}
                maxWidth="lg"
                id="edit-dialog"
            >

                {<NewOrEdit rowData={editData} columns={columns} changedData={handleChangedData} lovs={{}} />}

                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                    <Button
                        id="update-item-button"
                        onClick={handleUpdate}
                        disabled={isEditing}
                        autoFocus >
                        Update
                    </Button>
                </DialogActions>


            </Dialog>
        </div>
    )
}


function getColumns(columns: columns.ColumnInfo[]): columns.ColumnInfo[] {
    const newColsWithIdHidden = columns.map((col) => {
        if (col.id === 'id') {
            col.hidden = true;
        }
        return col;
    });

    const newColsFiltered = newColsWithIdHidden.filter((col) => {

        if (col.type !== 'action') {
            return col;
        }
    });

    return newColsFiltered;
}